import { useEffect } from 'react';

import { setAxiosConfig } from '@app/services';
import { getAccessToken } from '@app/utils';

// Интервал повтора проверки сессии, пока бэкенд недоступен (issue/11376):
// достаточно редко, чтобы не создавать нагрузку при выкате, и достаточно часто,
// чтобы раздел вернулся через несколько секунд после установки обновления.
const SESSION_CHECK_RETRY_INTERVAL_MS = 5_000;

interface Props {
  homePageRedirect(): void;
  getCountriesHandler(): Promise<void>;
  storeRoutesHandler(): void;
  connectListenUser(): void;
  authenticateHandler: () => Promise<void>;
  isSessionCheckPostponed: boolean;
  fetchBranchLightHandler(): Promise<void>;
  showFullSidebar: () => void;
}
export const usePageEffects = ({
  homePageRedirect,
  getCountriesHandler,
  storeRoutesHandler,
  connectListenUser,
  authenticateHandler,
  isSessionCheckPostponed,
  fetchBranchLightHandler,
  showFullSidebar,
}: Props) => {
  const accessToken = getAccessToken();

  useEffect(() => {
    setAxiosConfig();
  }, [accessToken]);

  useEffect(() => {
    homePageRedirect();
  }, [homePageRedirect]);

  useEffect(() => {
    getCountriesHandler();
  }, [getCountriesHandler]);

  useEffect(() => {
    storeRoutesHandler();
  }, [storeRoutesHandler]);

  useEffect(() => {
    connectListenUser();
  }, [connectListenUser]);

  useEffect(() => {
    authenticateHandler();
  }, [authenticateHandler]);

  useEffect(() => {
    if (!isSessionCheckPostponed) return undefined;

    const intervalId = window.setInterval(
      authenticateHandler,
      SESSION_CHECK_RETRY_INTERVAL_MS
    );

    return () => window.clearInterval(intervalId);
  }, [isSessionCheckPostponed, authenticateHandler]);

  useEffect(() => {
    fetchBranchLightHandler();
  }, [fetchBranchLightHandler]);

  useEffect(() => {
    showFullSidebar();
  }, [showFullSidebar]);
};
